import http from '@/plugins/request'
//调仓单列表
export const transferWarehousing = (params) => {
    return http.request({
        url: 'fch/pda/transferWarehousing',
        method: 'get',
        params
    })
}

//待完成的调仓单列表
export const transferWarehousingPending = (params) => {
    return http.request({
        url: 'fch/pda/transferWarehousing/pending',
        method: 'get',
        params
    })
}

//调仓单详情
export const transferWarehousingMore = (transfer_warehousing_sn) => {
    return http.request({
        url: 'fch/pda/transferWarehousing/'+transfer_warehousing_sn,
        method: 'get'
    })
}
//调仓单二维码明细
export const transferWarehousingCodeMore = (params) => {
    return http.request({
        url: 'fch/pda/transferWarehousing/code/'+params.transfer_warehousing_sn,
        method: 'get',
        params
    })
}

//调仓单扫码
export const transferWarehousingScan = (data) => {
    return http.request({
        url: 'fch/pda/transferWarehousing/scan',
        method: 'post',
        data
    })
}
//调仓单调仓
export const transferWarehousingCodeTransfer = (transfer_warehousing_sn) => {
    return http.request({
        url: 'fch/pda/transferWarehousing/codeTransfer/'+transfer_warehousing_sn,
        method: 'post'
    })
}
//获取调仓单号
export const getTransferWarehousingCode = () => {
    return http.request({
        url: 'fch/pda/transferWarehousing/code',
        method: 'get'
    })
}
